import Image from "next/image";
import React from "react";
import style from "../BlogPage.module.scss";
import { BlogCardType } from "@/components/page-modules/blog/data/blog.types";
export const BlogTitle: React.FC<BlogCardType> = ({
  blogData
}) => {
  return <>
      <header className={style.header}>
        <h1 className={style.title}>{blogData.title}</h1>
        <div className={style.blog__info}>
          <p> {blogData.author?.name}</p>
          <p> {blogData.createdAt}</p>
          <p> {blogData.readTime} read</p>
        </div>
      </header>

      {blogData.image && <div className={style.blog_image}>
          {!blogData.qrType ? <Image src={blogData.image} width={1262} height={646} alt={blogData.imageAltAttribute} /> : null}
        </div>}
    </>;
};